<template>
	<section class="country-white-list">
		<div class="country-intro">
			<div class="intro-icon"><i class="el-icon-location-information" /></div>
			<div>
				<h3>国家白名单</h3>
				<p>仅允许列表中的国家或地区访问；未配置时不限制国家。</p>
			</div>
		</div>

		<div class="country-adder">
			<el-select v-model="selectCountry" :disabled="!isAdmin" multiple filterable clearable collapse-tags placeholder="选择允许访问的国家或地区">
				<el-option v-for="item in countryList" :key="item.code" :label="item.name" :value="item.name" />
			</el-select>
			<el-button v-if="isAdmin" type="primary" icon="el-icon-check" :loading="saving" @click="handleSubmit">保存白名单</el-button>
		</div>

		<div class="country-list-card">
			<div class="country-list-title">
				<div><span>当前生效列表</span><small>访问拦截策略会自动更新</small></div>
				<el-tag type="success" effect="light">{{ dataListCountry.length }} 个国家/地区</el-tag>
			</div>
			<el-table v-loading="listLoading" :data="dataListCountry" class="country-table" empty-text="暂未限制国家访问">
				<el-table-column label="序号" width="90"
					><template slot-scope="{ $index }">#{{ $index + 1 }}</template></el-table-column
				>
				<el-table-column label="国家或地区" min-width="240"
					><template slot-scope="{ row }"
						><span class="country-name"><i class="el-icon-location-outline" /> {{ row.name }}</span></template
					></el-table-column
				>
				<el-table-column label="策略" width="130"
					><template><el-tag size="mini" type="success">允许访问</el-tag></template></el-table-column
				>
			</el-table>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'CountryWhiteList',
		data() {
			return { listLoading: false, saving: false, countryList: [], dataListCountry: [], selectCountry: [] };
		},
		computed: {
			isAdmin() {
				const info = JSON.parse(sessionStorage.getItem('admin-info') || '{}');
				return Number(info.group_id) === 99;
			}
		},
		created() {
			this.loadCountryConfig();
		},
		methods: {
			loadCountryConfig() {
				this.listLoading = true;
				this.request
					.get('/system', { params: { key: 'COUNTRY' } })
					.then((res) => {
						this.countryList = res.country || [];
						const value = res.white_country || '';
						this.dataListCountry = value
							? value
									.split(',')
									.filter(Boolean)
									.map((name) => ({ name }))
							: [];
						this.selectCountry = this.dataListCountry.map((item) => item.name);
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			handleSubmit() {
				this.saving = true;
				this.request
					.post('/country-add', { country: this.selectCountry.join(',') })
					.then(() => {
						this.$message.success('国家白名单已保存');
						this.loadCountryConfig();
					})
					.finally(() => {
						this.saving = false;
					});
			}
		}
	};
</script>

<style scoped>
	.country-intro {
		display: flex;
		align-items: center;
		gap: 13px;
		margin-bottom: 16px;
		padding: 15px 17px;
		border: 1px solid #dcebea;
		border-radius: 9px;
		background: #f4faf9;
	}
	.intro-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		border-radius: 10px;
		color: #2c857a;
		background: #e1f2ee;
		font-size: 19px;
	}
	.country-intro h3 {
		margin: 0;
		color: #315a58;
		font-size: 16px;
	}
	.country-intro p {
		margin: 5px 0 0;
		color: #66817f;
		font-size: 13px;
	}
	.country-adder {
		display: flex;
		gap: 10px;
		margin-bottom: 16px;
		padding: 14px;
		border-radius: 9px;
		background: #f8fafb;
	}
	.country-adder .el-select {
		flex: 1;
	}
	.country-list-card {
		overflow: hidden;
		border: 1px solid #dfe9e8;
		border-radius: 8px;
	}
	.country-list-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 11px 14px;
		color: #476463;
		font-size: 13px;
		font-weight: 600;
		background: #f5faf9;
	}
	.country-list-title small {
		display: block;
		margin-top: 3px;
		color: #8a9b9a;
		font-size: 12px;
		font-weight: 400;
	}
	.country-table {
		width: 100%;
	}
	.country-name {
		color: #315f78;
		font-size: 14px;
	}
	.country-name i {
		color: #4a968e;
	}
	@media (max-width: 640px) {
		.country-adder {
			flex-direction: column;
		}
		.country-adder .el-button {
			width: 100%;
		}
	}
</style>
